<template>
  <div class="preOrder">
    <headBox title="预约单跟进" class="headerBox">
      <ahb-header :num="nums"></ahb-header>
    </headBox>
    <div class="content">
     <topSearchForm @search="searchfun" :hiddenExport="true" :showSwtich="true">
       <el-form :inline="true" class="rform" :model="search" ref="loginform">
          <el-form-item label="" class="less small">
            <div class="cell-border">
              <el-select class="left-select" v-model="search.timeType" placeholder="请选择">
                <el-option value="1" label="预约时间"></el-option>
                <el-option value="2" label="创建时间"></el-option>
              </el-select>
              <a-range-picker class="date-picker" v-model="search.data" format="yyyy-MM-DD" valueFormat="yyyy-MM-DD" separator="至">
                <i class="icon-riqixuanze" slot="suffixIcon"></i>
              </a-range-picker>
            </div>
          </el-form-item>
          <el-form-item label="预约信息" class="less small1">
            <el-input v-model="search.info" placeholder="姓名或电话" clearable></el-input>
          </el-form-item>
          <el-form-item label="微信号" class="small1">
            <el-input v-model="search.wechat" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="关注的产品">
            <el-input v-model="search.productName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="预约状态">
            <el-select clearable v-model="search.selet" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型">
            <el-radio-group v-model="search.consultType" @input="searchfun()" >
              <el-radio label="">全部</el-radio>
              <el-radio label="1">新资源</el-radio>
              <el-radio label="2">重复资源</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="预约来源">
            <el-select clearable v-model="search.source" placeholder="请选择">
              <el-option v-for="(item,i) in sourceList" :key="i" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单类型">
            <el-select class="only-select" clearable v-model="search.selet1" placeholder="请选择">
              <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否成交">
            <el-select clearable v-model="search.isDeal" placeholder="请选择">
              <el-option label="是" value="1">是</el-option>
              <el-option label="否" value="0">否</el-option>
            </el-select>
          </el-form-item>
       </el-form>
     </topSearchForm>
    </div>
    <div class="info-box">
      <div class="total-num">
        <span>共</span>
        <span class="num-color">{{total}}</span>
        <span>单</span>
      </div>
      <div>
        <span>成交保单数: </span>
        <span class="num-color">{{statistics.totalNum}}单</span>
      </div>
      <div>
        <span>成交保费: </span>
        <span class="num-color">{{statistics.totalFee}}元</span>
      </div>
      <div>
        <span>成交服务费: </span>
        <span class="num-color">{{statistics.totalIncomes}}元</span>
      </div>
      <el-button class="derive-btn" @click="exportPolicyExcel">导出</el-button>
      <el-upload
        class="upload-btn"
        :action="
          $config.api_root + '/master/subscribeService/importResource'
        "
        :show-file-list="false"
        :on-success="fileSuccess"
        :before-upload="fileUpload"
        name="file"
        v-if="showImport"
      >
        <el-button class="drbtn-yy" type="warning" plain>导入</el-button>
      </el-upload>
      <el-button class="items cxbtn" type="text" @click="downloadFile" v-if="showImport">下载模板</el-button>
    </div>
    <div class="body-card" v-loading="loading">
      <div class="info-body clearfix">
        <div class="table-head table-row">
          <el-row :gutter="20">
            <el-col :span="5"><div>预约人姓名/手机号</div></el-col>
            <el-col :span="4"><div>预约来源</div></el-col>
            <el-col :span="2"><div style="white-space: nowrap;">第几次咨询</div></el-col>
            <el-col :span="3"><div>关注的产品</div></el-col>
            <el-col :span="3"><div>预约状态</div></el-col>
            <el-col :span="4"><div style="white-space: nowrap;">成交保单数<span>/成交保费（元）</span></div></el-col>
            <el-col :span="3"><div>操作</div></el-col>
          </el-row>
        </div>

        <div v-for="(item, index) in tableData" :key="index">
          <div class="table-info">
            <div class="new-time" v-if="showTime">预约时间：{{item.consultTime|timeStatus}}</div>
            <div class="new-time" v-else>创建时间：{{item.createTime|timeStatus}}</div>
            <div class="tag" v-if="item.consultNum>1">重复资源</div>
            <div class="right">
              <div class="account-info">所属账户：{{item.mechanUserName}}</div>
              <div class="order-type">订单类型：{{item.status == "81" ? "渠道跟进" : "客服跟进"}}</div>
            </div>
          </div>
          <div class="card">
            <div class="table-row table-info1">
              <el-row :gutter="20">
                <el-col :span="5"><div><tooltip :txt-info="(item.name||'-') + '/' + (item.mobile||'-')"></tooltip></div></el-col>
                <el-col :span="4"><div>{{ (item.title||item.entrance||item.sourceDesc)|filterEmpty }}</div></el-col>
                <el-col :span="2"><div>{{item.consultNum|filterEmpty}}</div></el-col>
                <el-col :span="3"><div><tooltip :txt-info="item.productName|filterEmpty"></tooltip></div></el-col>
                <el-col :span="3"><div>{{(
                    item.status == "81" ||
                    item.status == "11" ||
                    item.status == "12"
                      ? "跟进中"
                      : all.SERVICE_STATUS[item.status]) || '-'
                  }}</div></el-col>
                <el-col :span="4"><div>{{item.totalNum|filterEmpty}}<span v-if="item.totalNum&&item.totalIncomes">/</span><span>{{item.totalIncomes|filterEmpty}}</span></div></el-col>
                <el-col :span="3"><div class="cz-list"><span class="xqbtn" @click="seeDetail(item)">详情</span></div></el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <div class="empty" v-if="tableData.length==0">
        <p>
          <img src="@static/images/no_msg.png" style="width:290px"/>
        </p>
        <p><span>暂无数据</span></p>
      </div>
    </div>
    <el-pagination
        background
        v-if="tableData.length!=0"
        :current-page.sync="current"
        @size-change="handleSizeChange"
        :layout="$tools.pageLayout"
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="pageSize"
      >
    </el-pagination>
    <modalLoading ref="modalLoading"></modalLoading>
  </div>
</template>
<script>
//    1: "预约中"
// 2: "客服联系中"
// 3: "已出单"
// 9: "已放弃"
import common from "../../api/common.js";
import tooltip from "@/components/tooltip";
import athHeader from "../../components/authorizationTitle";
import modalLoading from "../../components/modalLoading";
import topSearchForm from "../../components/topSearchForm";
import headBox from "@/components/head.vue";
export default {
  name: "preOrder",
  data: () => ({
    userFlag:false,
    showTime:true, // true 最新预约时间 ,false 创建时间
    loading:true,
    nums: 0,
    tableData: [],
    all: {},
    total: 0,
    value: "",
    current: 1,
    search: {
      timeType:'1',// 时间类型
      productName:'',// 产品名称
      data: [],//时间
      wechat:'',//微信号
      info: "",
      selet: "",
      selet1: "",
      source: "",
      consultType: "",//类型 1 新资源 2 重复资源
      isDeal:'',//是否成交
    },
    statistics:{},
    // 1: "待跟进"
    // 11: "确认客户需求"
    // 12: "推荐合适产品"
    // 91: "已成交"
    // 92: "未促成"
    // 93: "无效记录"
    sourceList:[],
    options: [
      { label: "待跟进", value: 1 },
      { label: "跟进中", value: 10 },
      { label: "已成交", value: 91 },
      { label: "未促成", value: 92 },
      { label: "无效记录", value: 93 },
    ],
    options1: [
      { label: "渠道跟进", value: 81 },
      { label: "客服跟进", value: 80 },
    ],
    showImport: false,
    userInfo: {},
    pageSize:10,
  }),
  components: {
    modalLoading,
    headBox,
    topSearchForm,
    "ahb-header": athHeader,
    tooltip
  },
  mounted() {
    this.$tools.getall(this.setAll);
    this.userInfo = this.$tools.getLocal("userinfo");
    this.getSourceList();
    this.getUserInfo()
  },
  methods: {
    getUserInfo(){
        const data = this.$tools.getLocal("userinfo");
        // 1一级机构 2二级机构 3员工
        if(data.level!=3){
            this.userFlag = true
        }
      },
    // 获取来源列表
    getSourceList(){
      this.$http({
        url: "/master/subscribeService/querySourceListV2",
        type: "put",
        params:{}
      }).then((res)=> {
        this.sourceList = res.data;
      })
    },
    // 页容量改变
    handleSizeChange(num){
      this.pageSize = num;
      this.subscribeService(1);
    },
    // 下载模板
    downloadFile() {
      window.open(
        `${this.$config.api_root}/master/subscribeserviceTpl/${this.userInfo.mechanId}.xlsx`
      );
    },
    // 上传回调
    fileSuccess: function (res, file) {
      if (res.httpCode != 200) {
        this.$message.error(res.msg);
        this.$refs.modalLoading.close();
      } else {
        this.fileErrorVisible = true;
        this.fileError = res.data;
        this.$refs.modalLoading.setText({
          title: "上传成功",
          progress: 100,
        });
        this.searchfun();
      }
    },
    // 上传文件
    fileUpload: function (file) {
      console.log(file);
      const type = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (type != "xls" && type != "xlsx") {
        this.$message.warning("请上传xls或者xlsx格式的文件");
        return false;
      }
      // const isLt2M2 = file.size / 1024 < 500;
      // if (!isLt2M2) {
      //     this.$notice.msg("上传banner图片大小不能超过 500kb!", 2);
      // }
      // return isLt2M2;
      this.$refs.modalLoading.open({
        title: "上传数据中，请稍等",
      });
      return true;
    },
    setAll: function (data) {
      this.all = data;

      this.subscribeService(1);
    },
    subscribeService: function (pageNum) {
      var that = this;
      var obj = {
        pageNum: pageNum,
        pageSize: this.pageSize,
        status: that.search.selet,
        orderStatus: that.search.selet1,
        source: that.search.source,
        wechat: that.search.wechat,
        productName: that.search.productName,
        isDeal:that.search.isDeal,
        timeType:that.search.timeType,
        consultType:that.search.consultType
      };
      if (this.search.data&&this.search.data.length) {
        if(this.search.timeType==1){
          obj.consultStartTime  = that.search.data[0];
          obj.consultEndTime = that.search.data[1];
        }else if(this.search.timeType==2){
          obj.startTime = that.search.data[0];
          obj.endTime = that.search.data[1];
        }
      }
      if(this.search.timeType==1){
        //显示最新预约时间
        this.showTime = true
      }else if(this.search.timeType==2){
        // 显示创建时间
        this.showTime = false
      }
      if (isNaN(that.search.info * 1)) {
        obj.name = that.search.info;
      } else {
        obj.mobile = that.search.info;
      }
      for (var key in obj) {
        if (obj[key] === "") {
          delete obj[key];
        }
      }
      this.$http({
        url: "/master/subscribeService/list",
        type: "put",
        params: obj,
      }).then(function (data) {
        that.loading = false;
        that.tableData = data.data;
        that.total = data.total;
        that.statistics = data.statistics
        that.showImport = data.openImport == 1;
      });
    },
    handleCurrentChange: function (val) {
      this.subscribeService(val);
    },
    seeDetail: function (obj) {
      this.$router.push({
        path: "/procedure",
        query: {
          id: obj.id,
          productName: obj.productName,
        },
      });
    },
    searchfun: function () {
      console.log("searchfun")
      this.current = 1;
      this.subscribeService(1);
    },
    exportPolicyExcel: function () {
      var str = `/master/subscribeService/export/subscribe?status=${this.search.selet}&source=${this.search.source}&wechat=${this.search.wechat}&productName=${this.search.productName}&isDeal=${this.search.isDeal}&orderStatus=${this.search.selet1}`;
      if (isNaN(this.search.info * 1)) {
        str += "&name=" + this.search.info;
      } else {
        str += "&mobile=" + this.search.info;
      }
      if (this.search.data && this.search.data.length) {
        if(this.search.timeType==1){
          str += "&consultStartTime="+this.search.data[0]+"&consultEndTime="+this.search.data[1]
        }else if(this.search.timeType==2){
          str += "&startTime="+this.search.data[0]+"&endTime="+this.search.data[1]
        }
      }
      this.$tools.daochu(str);
    },
    gosq: function () {
      this.$router.push({
        path: "/setting/auth",
        query:{source:'1'}
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./preOrder";
@import "./component/common_form";
.headerBox {
  .info-box {
    .ath {
      width: 100%;
      background: #f7f7f7;
      margin-bottom: 0;
      padding-left: 0;
    }
  }
}
</style>
